import { createApi, } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";

export const ImportAdditionalInfoApi = createApi({
    reducerPath: "ImportAdditionalInfoApi",
    baseQuery,
    tagTypes: ["ImportAdditionalInfo"],
    endpoints: (builder) => ({

        getImportAdditionalInfoById: builder.query({
            query: ({id} ) => `/import/product/additionalInfo/${id}`,
            transformResponse: (response) => {
              const data = response?.data ?? [];
              const normalized = Array.isArray(data) ? data : [data];
      
              return normalized.map((item) => ({
                ...item,
                id: item.importAdditionalinfoId, 
              }));
            },
            providesTags: ["ImportAdditionalInfo"],
          }),

        createImportAdditionalInfo: builder.mutation({
            query: ({id  , ...data}) => ({
              url: `/import/product/additionalInfo/${id}`,
              method: "PUT", 
              body: { importAdditionalinfo:data },
              headers: {
                "X-Request-Id":`${Date.now()}`,
              },
            }),
            invalidatesTags: ["ImportAdditionalInfo"],
          }),

          updateImportAdditionalInfo: builder.mutation({
            query: ({ id ,subId, ...data  }) => ({
              url: `/import/product/additionalInfo/${id}/${subId}`,
              method: "PUT",
              body: { importAdditionalinfo:data},
              headers: {
                "X-Request-Id":`${Date.now()}`,
              },
            }),
            invalidatesTags: ["ImportAdditionalInfo"],
          }),

          deleteImportAdditionalInfo: builder.mutation({
            query: ({ id }) => ({
              url: `/import/product/additionalInfo/${id}`,
              method: "DELETE",
              headers: {
                "X-Request-Id":`${Date.now()}`, 
              },
            }),
            invalidatesTags: ["ImportAdditionalInfo"],
          }),
    }),
});

export const {
    useLazyGetImportAdditionalInfoByIdQuery,
    useCreateImportAdditionalInfoMutation,
    useUpdateImportAdditionalInfoMutation,
    useDeleteImportAdditionalInfoMutation,
} = ImportAdditionalInfoApi;
